import styled from "@emotion/styled";
import { Close } from "@mui/icons-material";
import { IconButton, Typography, useTheme } from "@mui/material";
import { Box } from "@mui/system";
import { ExportPaymentCheckQuery } from "components/gql/queris/ExportPaymentCheck";
import { OrderReadQuery } from "components/gql/queris/GetOrderInfo";
import { GetCode } from "contexts/CodeContext";
import { GetCInfo } from "contexts/CompanyContext";
import { GetData } from "contexts/DataContext";
import { isObjectEmpty } from "data/functions";
import SbpLogo from "data/images/sbp.svg";
import QRCodeStyling from "qr-code-styling";
import { QRCodeSVG } from "qrcode.react";
import React, { useEffect, useRef, useState } from "react";
// import { useAuth } from "react-oidc-context";
import { useNavigate } from "react-router-dom";

const QrDiv = styled.div`
  // min-height: 250px;
  svg {
    height: auto;
    max-height: 50vh;
    // width: 100%;
    max-width: 100%;
    border-radius: 36px;
  }
  canvas {
    height: auto;
    max-height: 40vh;
    // width: 100%;
    max-width: 100%;
    border-radius: 36px;
  }
`;

export function Main(props) {
  const { code, deleteCode } = GetCode();
  const { dataObj } = GetData();
  const { cInfo } = GetCInfo();
  const navigate = useNavigate();
  const theme = useTheme();
  const [paymentCheckQuery] = ExportPaymentCheckQuery();
  // const auth = useAuth();
  const [orderGQL] = OrderReadQuery();

  React.useEffect(() => {
    if (code?.paymentID && code?.clientID && code?.orderID) {
      const fetchData = async (companyUuid, orderID, paymentID, clientID) => {
        let success = await checkPayment(
          companyUuid,
          orderID,
          paymentID,
          clientID
        );
        if (success) {
          // console.log("Something done");
          setTimeout(() => {
            orderGQL({
              variables: {
                companyUUID: companyUuid,
                orderId: orderID,
                userID: clientID,
              },
            });
            setTimeout(() => {
              navigate(`/orders/${orderID}`, {
                state: {
                  clientID: clientID,
                  orderID: orderID,
                },
              });
            }, 200);
            // console.log("Delayed for 3 second.");
          }, 3000);
          clearInterval(timerInterval);
        }
      };
      const timerInterval = setInterval(() => {
        fetchData(cInfo?.UUID, code?.orderID, code?.paymentID, code?.clientID);
      }, 5000);

      // Cleanup the interval when the component unmounts
      return () => clearInterval(timerInterval);
    }
  }, [code, cInfo?.UUID]);

  useEffect(() => {
    if (isObjectEmpty(code) || code?.orderUrl === "") {
      navigate("/");
    }
  }, [code]);

  async function checkPayment(companyUuid, orderID, paymentID, clientID) {
    if (!orderID || !paymentID) {
      return;
    }

    let { data, error } = await paymentCheckQuery({
      variables: {
        companyUuid: companyUuid,
        orderId: orderID,
        paymentId: paymentID,
        userId: clientID,
      },
    });
    if (data) {
      if (data?.export_paymentCheck?.code === 200) {
        return true;
      } else {
        return false;
      }
    }
    if (error) {
      return false;
    }
    return false;
  }

  return (
    <React.Fragment>
      <IconButton
        onClick={() => deleteCode()}
        sx={{ position: "absolute", right: "12px", top: "12px" }}
      >
        <Close sx={{ opacity: "0.2" }} />
      </IconButton>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          height: "100%",

          alignItems: "center",
          //https://colorgradient.dev/gradient-generator/
          backgroundImage:
            // !dataObj?.zoom || dataObj?.zoom === 100
            true
              ? `radial-gradient(50% 50% at 108% 24%, #1403FF45 0%, #073AFF00 100%), radial-gradient(80% 80% at -35% 54%, #FF00004A 13%, #FF000000 99%), radial-gradient(61% 39% at 52% 114%, #B3FFADFF -310%, ${theme?.palette?.background?.default} 57%)`
              : "unset",
          backgroundPosition: "0px 0px,0px 0px,0px 0px",
          backgroundSize: "100% 100%",
          justifyContent: "center",
        }}
      >
        <Box
          sx={{
            alignItems: "center",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            maxWidth: "512px",
            overflow: "auto",
            padding: "1.2rem",
            transform: dataObj?.zoom
              ? `scale(${dataObj?.zoom / 100})`
              : undefined,
          }}
        >
          <Box
            sx={{
              alignItems: "center",
              display: "flex",
              flexDirection: "column",
              justifyContent: "flex-start",
              padding: "1.2rem 0",
              width: "100%",
            }}
          >
            <Typography
              sx={{ fontWeight: "700", lineHeight: 1, padding: "0 0.4rem" }}
              variant="h1"
            >
              {code?.orderSum && !isNaN(parseFloat(code?.orderSum / 100))
                ? parseFloat(code?.orderSum / 100) + " руб."
                : ""}
            </Typography>
            {/* <Typography
              sx={{ padding: "0.4rem", fontWeight: "700", lineHeight: 1 }}
              variant="h4"
            >
              Ожидание оплаты
            </Typography> */}
          </Box>
          <Box
            sx={{
              display: "flex",

              alignItems: "stretch",
              flexDirection: "row",
              gap: "2vw",
              justifyContent: "center",
            }}
          >
            {code?.orderUrl && (
              <QRCodeBlock
                color1={"#000352"}
                color2={"#000352"}
                image={SbpLogo}
                url={code?.orderUrl}
              />
            )}
          </Box>
          <Box sx={{ width: "100%" }}>
            {code?.orderDescription && (
              <Typography
                sx={{
                  fontWeight: "700",
                  padding: "0.4rem",
                  textAlign: "center",
                }}
                variant="h4"
              >
                {code?.orderDescription}
              </Typography>
            )}
          </Box>
        </Box>
      </Box>
    </React.Fragment>
  );
}

export function QRCodeBlock(props) {
  const ref = useRef(null);

  const qrCode = new QRCodeStyling({
    backgroundOptions: { color: "#ffffff", round: 0 },
    cornersSquareOptions: {
      color: "#000000",
      gradient: {
        colorStops: [
          { color: props?.color1 ? props?.color1 : "#040b1b", offset: 0 },
          // { color: props?.color1 ? props?.color1 : "#0b603b", offset: 0.5 },
          { color: props?.color1 ? props?.color1 : "#040b1b", offset: 1 },
        ],
        rotation: 0.7853981633974483,
        type: "radial",
      },
      type: "extra-rounded",
    },
    data: props?.url ? props?.url : "",
    dotsOptions: {
      color: "#6a1a4c",
      gradient: {
        colorStops: [
          { color: props?.color1 ? props?.color1 : "#000352", offset: 0 },
          { color: props?.color1 ? props?.color1 : "#06b13a", offset: 0.5 },
          { color: props?.color2 ? props?.color2 : "#06b13a", offset: 1 },
        ],
        rotation: 0.7853981633974483,
        type: "linear",
      },
      roundSize: true,
      type: "extra-rounded",
    },

    height: 1024,
    image: props?.image ? props?.image : "",
    imageOptions: {
      hideBackgroundDots: true,
      imageSize: 0.3,
      margin: 6,
      saveAsBlob: true,
    },
    margin: 72,
    qrOptions: { errorCorrectionLevel: "Q", mode: "Byte", typeNumber: "0" },
    shape: "square",
    type: "canvas",
    width: 1024,
  });

  useEffect(() => {
    try {
      ref && ref?.current?.replaceChildren();
    } catch (error) {
      if (ref && ref.current) {
        ref.current.innerHTML = "";
      }
    }

    ref && ref?.current && qrCode.append(ref.current);
  }, []);

  return (
    <QrDiv
      ref={ref}
      // style={{ "&svg": { width: "100%!important", maxWidth: "512px" } }}
    />
  );
}

// export function QRBlock(props) {
//   const ref = useRef(null);
//   let element = ref?.current?.querySelector("svg");
//   const [hide, setHide] = useState(true);

//   const resizeObserver = new ResizeObserver((entries) => {
//     window.requestAnimationFrame(() => {
//       if (!Array.isArray(entries) || !entries.length) {
//         return;
//       }
//       for (const entry of entries) {
//         if (entry.contentBoxSize) {
//           const contentBoxSize = entry.contentBoxSize[0];
//           // console.log(contentBoxSize);
//           element.style.padding = `${contentBoxSize.inlineSize * 0.17}px`;
//           // h1Elem.style.fontSize = `${Math.max(
//           //   1.5,
//           //   contentBoxSize.inlineSize / 200,
//           // )}rem`;
//           // pElem.style.fontSize = `${Math.max(
//           //   1,
//           //   contentBoxSize.inlineSize / 600,
//           // )}rem`;
//         } else {
//           console.info(entry.contentRect.width);
//           // h1Elem.style.fontSize = `${Math.max(
//           //   1.5,
//           //   entry.contentRect.width / 200,
//           // )}rem`;
//           // pElem.style.fontSize = `${Math.max(1, entry.contentRect.width / 600)}rem`;
//         }
//         setHide(false);
//       }
//     });

//     // console.log("Size changed");
//   });

//   useEffect(() => {
//     element && resizeObserver.observe(element);

//     return () => {
//       element && resizeObserver.unobserve(element);
//     };
//   }, [element]);

//   return (
//     <React.Fragment>
//       <Box
//         ref={ref}
//         sx={{
//           // padding: "2rem",
//           display: "flex",
//           visibility: hide ? "hidden" : "visible",
//           background: "white",
//           flexDirection: "column",
//           justifyContent: "center",
//           alignContent: "center",
//           alignItems: "center",
//           borderRadius: "20%",
//           overflow: "hidden",
//           maxWidth: "575px",
//           width: "100%",
//         }}
//       >
//         <QRCodeSVG
//           bgColor="white"
//           imageSettings={{
//             src: props?.srcImg ? props?.srcImg : SbpLogo,
//             height: 60,
//             width: 60,
//             excavate: true,
//           }}
//           size={512}
//           style={{
//             maxWidth: "512px",
//             width: "80%",
//             height: "auto",
//             background: "white",
//             // padding: "2rem",
//           }}
//           value={props?.url ?? "5systems.ru"}
//         />
//       </Box>
//     </React.Fragment>
//   );
// }
